@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.rate-label {
  display: flex;
  align-items: center;
  gap: 4px;
  color: @fulfillment-planner--rate-consumer--text-color;
  font-weight: @bold;
  font-size: 14px;
  white-space: pre;
}

.rate-and-refresh {
  display: flex;
  align-items: center;
  font-size: 16px;

  .refresh-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 20px;
    width: 20px;
    margin-left: 7px;
  }
}

.icon {
  height: 35px;
  transform: scale(0.55);
  fill: @fulfillment-planner--rate-third-party--fill-color;
}
